// extracted by mini-css-extract-plugin
export var numpadContainer = "_fx-1";
export var phoneButton = "_fx-0";